import  gql  from 'graphql-tag'

export const CREATE_CONTINGENT_QUOTA_PYME = gql`mutation contingentQuotaTdcPyme($input: ContingentQuotaTDCPymeMutationInput!){
    contingentQuotaTdcPyme(input: $input){
        contingentQuotaTDCPyme{
            id
            data
        }
        errors{
            field
            messages
        }
    }
}`;